export default __webpack_public_path__ + "static/media/untappd.7147ccb9.png";